import { render, staticRenderFns } from "./SecuDetail.vue?vue&type=template&id=4800310c&scoped=true"
import script from "./SecuDetail.vue?vue&type=script&lang=js"
export * from "./SecuDetail.vue?vue&type=script&lang=js"
import style0 from "./SecuDetail.vue?vue&type=style&index=0&id=4800310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800310c",
  null
  
)

export default component.exports